export interface RewardsTransactionRequestParams {
	pageNumber?: number;
	pageSize?: number;
	startDate?: string;
	endDate?: string;
	transactionType?: 'CREDIT' | 'DEBIT';
}

export interface GenericResponse<T> {
	requestSuccessful: boolean;
	responseMessage: string;
	responseCode: string;
	responseBody: T;
}

export interface Campaign {
	id?: string;
	campaignIdentifier?: string;
	campaignImage?: string;
	campaignDescription?: string;
	campaignTitle?: string;
	campaignStartDate?: string;
	campaignEndDate?: string;
	campaignStatus?: string;
	goals?: Goal[];
}

export interface ActiveCampaignEventData {
    hasActiveCampaign: boolean;
}


export const enum GoalFrequency {
    NONE = 'NONE',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY'
}

export const enum GoalType {
    BILL_PAYMENT = 'BILL_PAYMENT',
    ALL_BUSINESS_CARD_PAYMENT = 'ALL_BUSINESS_CARD_PAYMENT',
    INTRA_BANK_TRANSFER = 'INTRA_BANK_TRANSFER',
    INTER_BANK_DEPOSIT = 'INTER_BANK_DEPOSIT',
    ALL_DEPOSITS = 'ALL_DEPOSITS',
    INTRA_BANK_DEPOSIT = 'INTRA_BANK_DEPOSIT',
    BUSINESS_CARD_PAYMENT = 'BUSINESS_CARD_PAYMENT',
    CARD_PAYMENT = 'CARD_PAYMENT',
    INTER_BANK_TRANSFER = 'INTER_BANK_TRANSFER',
    ALL_TRANSFERS = 'ALL_TRANSFERS',
    AIRTIME_PURCHASE = 'AIRTIME_PURCHASE',
    DATA_PURCHASE = 'DATA_PURCHASE',
}

export interface Goal {
	uuid?: string;
	identifier?: string;
	campaignIdentifier?: string;
	externalIdentifier?: string;
	reward?: Reward;
	title?: string;
	description?: string;
	startDate?: string;
	endDate?: string;
	type?: GoalType;
	expectedOccurrences?: number;
	occurrences?: number;
	completed?: boolean;
	goalDeepLink?: string;
	goalFrequency?: GoalFrequency;
	rewardMode?: string;
	nextResetOn?: string;
	status?: string;
}

export enum RewardType {
	PERCENTAGE = 'PERCENTAGE',
	FLAT = 'FLAT'
}

export interface Reward {
	uuid?: string;
	name?: string;
	code?: string;
	description?: string;
	type?: RewardType;
	value?: number | null;
	percentageValue?: number | null;
	valueCap?: number | null;
}

export interface RewardsWalletBalanceResponse {
	amountEarned: number;
}
export interface WalletBalanceResponse {
	availableBalance: number;
	ledgerBalance: number;
}

export interface RewardTransactionsResponse {
	totalPages: number;
	totalElements: number;
	pageSize: number;
	pageNumber: number;
	narration: null;
	data: RewardTransaction[];
}

export interface RewardTransaction {
	reference: string;
	narration: string;
	transactionType: 'CREDIT' | 'DEBIT';
	amount: number;
	currencyCode: string;
	balanceBefore: number;
	balanceAfter: number;
	balanceUpdated: boolean;
	transactionTimestamp: string;
	metadata: null;
	channel: string;
	transactionCode: string;
}

export interface EligibilityResponse {
	eligibleRewardResponse: Array<EligibleRewardResponse>
}
export interface EligibleRewardResponse {
	goalIdentifier: string;
	campaignIdentifier: string;
	campaignName: string;
	campaignDescription: string;
	goalTitle: string;
	goalDescription: string;
	totalCount: number;
	maxCount: number;
	reward: Reward;
	rewardMode: string;
	goalFrequency: string;
	goalType: RewardEligibilityType;
	rewardEligible: boolean;
}

export type TransformedEligibility = EligibleRewardResponse;
export interface EligibilityGoal {
	goalIdentifier: string;
	campaignIdentifier: string;
	campaignName: string;
	description: string;
	totalCount: number;
	maxCount: number;
	reward: Reward;
	rewardMode: RewardMode;
}

export const enum RewardEligibilityType {
    INTER_BANK_TRANSFER = 'INTER_BANK_TRANSFER',
    INTRA_BANK_TRANSFER = 'INTRA_BANK_TRANSFER',
    ALL_TRANSFERS = 'ALL_TRANSFERS',
    AIRTIME_PURCHASE = 'AIRTIME_PURCHASE',
    BILL_PAYMENT = 'BILL_PAYMENT',
    INTER_BANK_DEPOSIT = 'INTER_BANK_DEPOSIT',
    INTRA_BANK_DEPOSIT = 'INTRA_BANK_DEPOSIT',
    ALL_DEPOSITS = 'ALL_DEPOSITS',
    DATA_PURCHASE = 'DATA_PURCHASE'
}

export enum PromoBannerState {
	INITIATE = 'INITIATE',
	SUMMARY = 'SUMMARY'
}

export const enum RewardMode {
	REWARD_ON_COMPLETION = 'REWARD_ON_COMPLETION',
	REWARD_ON_EACH_OCCURRENCE =  'REWARD_ON_EACH_OCCURRENCE', 
	REWARD_INDEFINITELY = 'REWARD_INDEFINITELY'
}
  
export interface DisplayBannerResponse {
	agentId: number;
	displayBanner: boolean;
};


export enum TourStepName {
	BALANCE = 1,
	CASH_OUT,
	BANNER,
	GOALS,
	HISTORY
}


export const enum PopoverDirection {
    top = 'top',
    left = 'left',
    right = 'right',
    bottom = 'bottom',
    topLeft = 'topLeft',
    topRight = 'topRight',
    bottomLeft = 'bottomLeft',
    bottomRight = 'bottomRight',
    leftTop = 'leftTop',
    leftBottom = 'leftBottom',
    rightTop = 'rightTop',
    rightBottom = 'rightBottom'
}

export interface TourStep {
    title: string;
    description: string;
    order: number;
    next: TourStepName;
    popoverDirection: PopoverDirection;
}

export enum HistoryFilterDateRange {
    today = 'Today',
    last7Days = 'Last 7 Days',
    last14Days = 'Last 14 Days',
    lastMonth = 'Last Month',
    lastQuarter = 'Last Quarter',
    custom = 'Custom'
}

export interface HistoryFilter {
	dateRange: string;
	startDate: Date;
	endDate: Date;
}